<!-- main app container -->
<div *ngIf="$isLogged | async" class="p-col-12">
  <p-menubar [model]="items"></p-menubar>
</div>
<div class="p-d-flex p-flex-column p-jc-center">
  <div class="p-col-12">
    <router-outlet></router-outlet>
  </div>
  <p-toast></p-toast>
</div>
